export const CARD_SECTION_ESTIMATE = 'Estimate'
